import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getService, postService } from "../../services/services";
import * as services from "../../services/services.json";
// import ImportExportIcon from '@material-ui/icons/ImportExport';
// import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
// import VisibilityIcon from '@material-ui/icons/Visibility';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
// import ReplyIcon from '@material-ui/icons/Reply';
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import ShareIcon from '@material-ui/icons/Share';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
// import Collapse from '@material-ui/core/Collapse';
import MuiAlert from '@material-ui/lab/Alert';
import TodayIcon from '@material-ui/icons/Today';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import Star from '@material-ui/icons/Star';
import RepeatIcon from '@material-ui/icons/Repeat';

import {
  Avatar,
  // Table,
  CircularProgress,
  // TableCell ,
  // TableContainer,
  // TableHead,
  // TableRow,
  // Paper,
  // Button,
  IconButton,
  // Box,
  // ButtonGroup,
  // Input,
  // InputBase,
  Divider,
  // Tabs,
  // Tab,
  AppBar,
  // InputAdornment,
  Toolbar,
  // Switch,
  Tooltip,
  // TextField,
  // Fab,
  Card,
  CardHeader,
  CardMedia,
  Typography,
  // Avatar,
  CardContent,
  CardActions,
  Checkbox,
  Grid,
  Snackbar,
  // Link,
  // Menu,
  // MenuItem
} from "@material-ui/core";

import './DetailSocialMedia.css';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const mapStateToProps = state => {
  return {
    acamar: state.acamar,
    appstate: state.appstate
  };
};

class DetailSocialMedia extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewNoItem:false,
      itemDetail:null,
      downloadInfo:false,
      severity:"success",
      items:[
        /*  {
        date:"2019-10-30T16:27:09Z", //da convertire
        title:"Resettled Refugees Start A New Chapter of Their Lives",
        description:"Since conflict erupted in Syria in 2011, the International Organization for Migration in Lebanon has assisted more than 100000 refugees to resettle to new ...",
        userName:"IOM - UN Migration",
        userScreenName:"xxx",
        userImage:"https://urldefense.com/v3/__http://pbs.twimg.com/profile_images/1487914551454621704/vgisO7WO_normal.jpg__;!!LQkDIss!GXHp4rCbLUz26gX2PnZSzQ1rjbG0fXuYu5DJgQeoIOJt7PyR_PAflKUYFanhfpferEMaPEVa-w$",
        thumbnailUrl:"https://urldefense.com/v3/__https://i.ytimg.com/vi/egYDuc2mDNw/hqdefault.jpg__;!!LQkDIss!GXHp4rCbLUz26gX2PnZSzQ1rjbG0fXuYu5DJgQeoIOJt7PyR_PAflKUYFanhfpferEOWZxR_hg$",
        url:"http://repubblica.it"
      },
      {
      date:"2019-10-30T16:27:09Z", //da convertire
      title:"",
      description:"Filippo",
      userName:"Cicco",
      userScreenName:"",
      userImage:"",
      thumbnailUrl:"https://urldefense.com/v3/__https://i.ytimg.com/vi/egYDuc2mDNw/hqdefault.jpg__;!!LQkDIss!GXHp4rCbLUz26gX2PnZSzQ1rjbG0fXuYu5DJgQeoIOJt7PyR_PAflKUYFanhfpferEOWZxR_hg$",
      url:"http://repubblica.it"
    }*/
  ],
  form: {
    appname: this.props.appstate.App.name,
    userId: this.props.appstate.App.user.userid,
    domain: this.props.appstate.App.user.domain,
    name: "",
    description: "",
    dest: "resource",
    type:"",
    url:"",
    isExtRes:true,
    title:"",
    right:"",
    linkright:"",
    degree:"",
    mediaLanguage:"",
    creator:"",
    dcRightsHolder:"",
    medialan:"",
    mediares:"",
    uriCoverExternalRes:"",
    publicStatusExtRes:""
  },
  order:"reup",
  search_name:""
}

}


componentDidMount() {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('id');

  // console.log("search_name "+myParam);
  this.setState({search_name:myParam});

  this.getSocialMedia(myParam);
}


getSocialMedia = (myParam) => {

  let self=this;
  let serviceurl = process.env.REACT_APP_DOMAIN + services.socialmedia_GET;
  serviceurl = serviceurl.replace("{APPNAME}", this.props.appstate.App.name);
  serviceurl = serviceurl.replace("{DOMAIN}", this.props.appstate.App.user.domain);
  serviceurl = serviceurl.replace("{SEARCH_NAME}", myParam);
  getService(serviceurl, function (err, result) {
    if (err) {

      return;
    }
    if (result.status === 200) {
      //    console.log(result.response);
      self.setState({itemDetail:result.response});
      self.loadDBCERTH(myParam); //in locale commentare la chiamata, perchè in locale non abbiamo il db di certh
      //return;
    }

    return;
  });
}

loadDBCERTH = (myParam) => {
  // console.log(myParam);
  let self=this;
  let serviceurl = process.env.REACT_APP_DOMAIN + services.db_CERTH;
  serviceurl = serviceurl.replace("{SOCIAL}", this.state.itemDetail.source.toLowerCase());
  serviceurl = serviceurl.replace("{SEARCH_NAME}", myParam);
  getService(serviceurl, function (err, result) {
    //    console.log(err);
    // console.log(result);
    if (err) {

      return;
    }
    //  if (result.status === 200) {
    //  console.log(result.response);
    //self.setState({itemDetail:result.response});
    self.loadItemsSocial(result.response);
    return;
    //}

  });
}


loadItemsSocial = (items) => {
  // console.log("loadItemsSocial "+items.length);
  var arrayItems=[];
  //caso in cui ritorna un solo record ed è anche last_record
  if(items.length===0 || (items.length===1 && items[0].last_record===true)){
    this.setState({viewNoItem:true});
    // console.log(this.state.viewNoItem);
    return;
  }


  //limitiamo a 200 invece di items.length
  let limit = items.length>200 ? 200 : items.length;
  for(let i=0;i<limit;i++){
    //quando troviamo l'ultimo elemento
    if(items[i].last_record===true)
    break;//usciamo dal for


    switch(this.state.itemDetail.source.toUpperCase()){
      case "YOUTUBE":
      arrayItems.push(
        {
          date:items[i].publishedAt,
          title:items[i].title,
          description:items[i].description,
          userName:items[i].channelTitle,
          userScreenName:"",
          userImage:"",
          thumbnailUrl:items[i].thumbnail_url_high,
          url:"https://www.youtube.com/watch?v="+items[i].videoId,
          order:items[i].order

          // date --- publishedAt //da convertire
          // title --- title
          // description --- description
          // userName --- channelTitle
          // userScreenName ---
          // userImage ---
          // thumbnailUrl --- thumbnail_url_high
        });
        break;
        case "TWITTER":
        arrayItems.push( //TWITTER
          {
            date:items[i].created_at,
            title:items[i].user.screen_name,
            description:items[i].full_text,
            userName:items[i].user.name,
            userScreenName:items[i].user.screen_name,
            userImage:items[i].user.profile_image_url,
            thumbnailUrl:"",
            url:"https://twitter.com/"+items[i].user.screen_name+"/status/"+items[i].id_str,
            order:items[i].retweet_count
            // date --- created_at //da convertire
            // title ---
            // description --- full_text
            // userName --- user.name
            // userScreenName --- user.screen_name
            // userImage --- profile_image_url
            // thumbnailUrl ---
          });
          break;
          case "DIGITALMEETS":
          arrayItems.push(
            {
              date:items[i].crawled_date.day+"T"+items[i].crawled_date.time+"Z",
              title:items[i].title,
              description:items[i].full_article,
              userName:"",
              userScreenName:"",
              userImage:"",
              thumbnailUrl:items[i].img_url ? items[i].img_url : "",
              url:items[i].source_url
            });

            /*
            {

            "_id":"ObjectId(""6234965650b103174bc46f4c"")",

            "article_title":"Have your say: EC consultation about digital culture",

            "date":"Posted on: 7 October 2019",

            "img_url":"https://www.digitalmeetsculture.net/wp-content/uploads/2019/10/consultation.png",

            "full_article":"img. from Europeana Pro blog. The European Union is now consulting on what the priorities will be for the first two years of the Digital Europe Programme, the new funding programme currently preparing for 2021-2022. Sufficient support for digital culture is not guaranteed – the programme covers a wide range of issues, activities and projects, and we all know that culture is often one of the first areas to get squeezed out.Vocal support for our work and our sector will give us the best chances of being allocated sufficient funding. Indeed, the proposal document (p. 5) says as much, putting important store on this stakeholder consultation. This consultation is an opportunity for you to make sure the Commission hears the voice of the cultural heritage sector, as the programme will boost investments in supercomputing, artiﬁcial intelligence, cybersecurity, advanced digital skills, and ensuring a wide use of digital technologies across the economy and society. Digital cultural heritage and Europeana are part of these technologies. Find out more about the consultation and take the online survey now. The consultation will close on 25 October. More on Europeana Pro blog.",

            "crawling_source":"www.digitalmeetsculture.net",

            "source_url":"https://www.digitalmeetsculture.net/article/have-your-say-ec-consultation-about-digital-culture/",

            "crawled_date":{

            "day":"2022-03-23",

            "time":"10:08:35"

          },

          "language":"en"

        }
        */
        break;
        case "AMNESTY":
        arrayItems.push(
          {
            date:items[i].crawled_date.day+"T"+items[i].crawled_date.time+"Z",
            title:items[i].title,
            description:items[i].full_article,
            userName:"",
            userScreenName:"",
            userImage:"",
            thumbnailUrl:items[i].image_url ? items[i].image_url : "",
            url:items[i].source_url
          });
          /*
          {

          "_id":"ObjectId(""623492f950b103174bc42999"")",

          "article_title":"Spain: Authorities must not deport asylum seeker Mohamed Benhlima to Algeria",

          "date":"March 15, 2022",

          "topics":[

          "News",

          "Algeria",

          "Europe",

          "and",

          "Central",

          "Asia",

          "Middle",

          "East",

          "and",

          "North",

          "Africa",

          "Spain",

          "Asylum",

          "Human",

          "Rights",

          "Defenders",

          "and",

          "Activists"

        ],

        "full_article":"Responding to the news that the Spanish authorities are planning to deport Mohamed Benhlima, an Algerian asylum-seeker, whistleblower and anti-corruption activist, Amna Guellali, Amnesty International’s Deputy Regional Director for the Middle East and North Africa, said: “The Spanish authorities are deeply aware of the grim fate that awaits Mohamed Benhlima if they deport him. Over the last two years, the Algerian authorities have stepped up their brazen prosecution of activists as they seek to crush all forms of dissent. “The international community has a moral responsibility to stand up for those who expose human rights violations and raise their voice against corruption. Spain must immediately quash its plans to deport Mohamed Benhlima and respect the principle of non-refoulement. “Under international law, nobody should be returned to a country where they would be in danger of suffering torture or other cruel, inhuman or degrading treatment. Deporting Mohamed Benhlima would represent a serious violation of Spain’s obligations under international human rights law.” Background Mohamed Benhlima is an Algerian citizen and a former military official turned whistleblower who exposed corruption among Algeria’s high-ranking military officials in 2019. He fled to Spain in September 2019 after being informed that his name was on a list of wanted military officials after he participated in the Hirak protest movement. He has since sought asylum in both Spain and France. The international community has a moral responsibility to stand up for those who expose human rights violations and raise their voice against corruption. Amna Guellali, Amnesty International On 7 January 2021, he was sentenced in absentia to 10 years in prison for sharing videos online that exposed corruption within the military. Amnesty International has documented the use of torture and other ill-treatment by Algerian security forces in at least four cases of activists arrested over the past three years for their participation in the Hirak. In a similar case, Spanish authorities extradited on 20 August 2021 former military official and asylum-seeker Mohmed Abdellah, who had sought refuge in Spain in November 2018 after he had publicly accused the Algerian military of corruption. Upon his extradition to Algeria, Mohmed Abdellah was taken directly to the “Antar” high security centre in Algiers. He remains in detention to date. During a court hearing on 2 January 2022, he publicly stated that he was subject to torture and ill-treatment in detention.",

        "image_url":"https://www.amnesty.org/en/wp-content/uploads/2022/03/MicrosoftTeams-image-8.png",

        "crawling_source":"www.amnesty.org",

        "source_url":"https://www.amnesty.org/en/latest/news/2022/03/spain-authorities-must-not-deport-asylum-seeker-mohamed-benhlima-to-algeria/",

        "crawled_date":{

        "day":"2022-03-18",

        "time":"15:48:32"

      },

      "language":"en"

    }
    */
    break;
    case "COURAGEOPPOSITION":
    arrayItems.push(
      {
        date:items[i].crawled_date.day+"T"+items[i].crawled_date.time+"Z",
        title:items[i].title,
        description:items[i].summary,
        userName:"",
        userScreenName:"",
        userImage:"",
        thumbnailUrl:items[i].image_url ? items[i].image_url : "",
        url:items[i].source_url
      });
      /*
      {

      "_id":"ObjectId(""6234967550b103174bc47385"")",

      "collection_title":"András Kisfaludy collection",

      "date_found":"1990",

      "summary":"András Kisfaludy’s collection suggests ways of interpreting retrospective gazes on the alternative culture of the socialist period. While Kisfaludy is the owner of a sizable private collection that concerns alternative and dissent culture of the era, he is more a creator than a collector of documents. During the late 1950s and early 1960s, he was a member of the famous youth gang called \"Kalef\" (in 2006, he made a film about the gang). From 1968… read more András Kisfaludy’s collection suggests ways of interpreting retrospective gazes on the alternative culture of the socialist period. While Kisfaludy is the owner of a sizable private collection that concerns alternative and dissent culture of the era, he is more a creator than a collector of documents. During the late 1950s and early 1960s, he was a member of the famous youth gang called \"Kalef\" (in 2006, he made a film about the gang). From 1968 to 1971, he was the percussionist of the underground band \"Kex.” Kisfaludy began to make documentary films on cultural opposition in the 1990s. The core of his oeuvre was done between the early 1990s and early 2000s. The status of the collection is special because the rights of the movies belong exclusively to András Kisfaludy, so the collection exists only as a private collection. However, the majority of his films are accessible via Youtube. read more read less",

      "location":"Budapest, Hungary",

      "topics":[

      "alternative",

      "lifestyles",

      "and",

      "resistance",

      "of",

      "the",

      "everydays",

      "avant-garde,",

      "neo-avant-garde",

      "music",

      "(rock,",

      "punk,",

      "alternative,",

      "classical,",

      "etc.)",

      "underground",

      "culture",

      "visual",

      "arts",

      "youth",

      "culture"

    ],

    "image_url":"http://cultural-opposition.eu/wp-content/themes/courage/getimage.php?pic=n26080/thumbnail_uploaded_image.jpg",

    "crawling_source":"cultural-opposition.eu",

    "source_url":"http://cultural-opposition.eu/registry/",

    "crawled_date":{

    "day":"2022-03-18",

    "time":"15:25:56"

  },

  "language":"en"

}
*/
break;
default:
console.log("nessun service");
break;
}
}

/*
associo title "en" con article_title/collection_title

description "en" con summary/full_article

image_url se ci sta

source_url al click sulla card
*/

this.setState({items:arrayItems});
}

//barra filtri function
order=(event) =>{
  console.log(event);

  switch (event.currentTarget.value) {
    case "source": // DA MODIFICARE PER SOURCE ANZICHE' SHORTNAME
    if (this.state.orderSource ==="asc"){
      let orderArray= this.itemsSortInverse("source");
      this.setState({items:orderArray,orderSource:"desc"});
    }else{
      let orderArray=this.itemsSort("source");
      this.setState({items:orderArray,orderSource:"asc"});
    }
    break;
    case "date":
    if (this.state.orderDate ==="asc"){
      let orderArray= this.itemsSortInverse("createdAt");
      this.setState({items:orderArray,orderDate:"desc"});
    }else{
      let orderArray=this.itemsSort("createdAt");
      this.setState({items:orderArray,orderDate:"asc"});
    }
    break;

    default:
    break;
  }

}

itemsSort =(itemToOrder) =>{
  let ascend = this.state.items.slice(); //copy array
  ascend.sort (function (a,b)
  {
    return a[itemToOrder].toString().localeCompare(b[itemToOrder].toString());
  }
);
return ascend;
}

itemsSortInverse = (itemToOrder) =>
{
  var descend = this.state.items.slice();
  descend.sort (function (a, b)
  {
    return b[itemToOrder].toString().localeCompare(a[itemToOrder].toString());
  }
);
return descend;
}

getStatus = (date) => {

  let now = Date.now();
  if((now-date)>300000)
  return "done";
  else return "updating";

}


downloadCard = (item) =>
{
  let self = this;
  console.log('stai facendo download di: '+item.userName);

  let titleCopy=  {};

  let descCopy=  {};
  if(item.title!=="")
  titleCopy[this.props.appstate.App.currentLanguage]=item.title;
  if(item.description!=="")
  descCopy[this.props.appstate.App.currentLanguage]=item.description;

  let newform= {
    appname: this.props.appstate.App.name,
    userId: this.props.appstate.App.user.userid,
    domain: this.props.appstate.App.user.domain,
    name:item.title,
    description: descCopy,
    dest: "resource",
    type:"webcloud",
    url:item.url,
    isExtRes:true,
    title:titleCopy,
    right:"IN COPYRIGHT",
    linkright:"",
    degree:"2d",
    mediaLanguage:this.props.acamar.configuration.Languages.default,
    creator:item.userName,
    dcRightsHolder:"",
    medialan:this.props.acamar.configuration.Languages.default,
    mediares:"first",
    uriCoverExternalRes:this.state.itemDetail.source ==="TWITTER" ? null : item.thumbnailUrl,
    publicStatusExtRes:""
  }
  this.setState({
    form: newform
  });
  console.log(JSON.stringify(this.state.form));

  postService(process.env.REACT_APP_DOMAIN + services.resourcemanager_external_res_POST, newform ,
    function (err, result) {

      if (err) {
        // console.log("errore");
        self.setState({downloadInfo:true, severity:"error"});
        return;
      }

      if (result.status === 201) {
        // console.log("success");
        self.setState({downloadInfo:true, severity:"success"});
      }

      return;
    })

  }

  handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({downloadInfo:false});
  };


/*  orderList = (event) =>{
    console.log(event.target);
    console.log(event.target.name);
    this.setState({order:event.target.name, items:[]});
    let self=this;

    let serviceurl = process.env.REACT_APP_DOMAIN + services.db_sort_CERTH;
    serviceurl = serviceurl.replace("{SOCIAL}", this.state.itemDetail.source.toLowerCase());
    serviceurl = serviceurl.replace("{SEARCH_NAME}", this.state.search_name);
    let queryOrder="";
    let valueOrder=-1;
    switch (this.state.itemDetail.source.toUpperCase()) {
      case "TWITTER":

      if(event.target.name==="dateup"){
      queryOrder="created_at";
      valueOrder=-1;
    }else if(event.target.name==="datedown"){
        queryOrder="created_at";
        valueOrder=1;
      }else if(event.target.name==="reup"){
        queryOrder="retweet_count";
        valueOrder=-1;
      }else if(event.target.name==="redown"){
        queryOrder="retweet_count";
        valueOrder=1;
      }
      serviceurl = serviceurl.replace("{ORDER_SORT}", JSON.stringify(queryOrder));
      serviceurl = serviceurl.replace("{VALUE_SORT}", JSON.stringify(valueOrder));


      break;
      case "YOUTUBE":
      if(event.target.name==="dateup"){
      queryOrder="publishedAt";
        valueOrder=-1;
      }else if(event.target.name==="datedown"){
        queryOrder="publishedAt";
          valueOrder=1;
      }else if(event.target.name==="reup"){
        queryOrder="order";
          valueOrder=-1;
      }else if(event.target.name==="redown"){
        queryOrder="order";
          valueOrder=1;
      }
      serviceurl = serviceurl.replace("{ORDER_SORT}", JSON.stringify(queryOrder));
      serviceurl = serviceurl.replace("{VALUE_SORT}", JSON.stringify(valueOrder));

      break;
      default:
      console.log("no social");
    }

    getService(serviceurl, function (err, result) {
      //    console.log(err);
      console.log(result);
      if (err) {

        return;
      }

      self.loadItemsSocial(result.response);
      return;


    });
  }*/

  orderList = (event) =>{

    let orderArray=[];


    //
    // switch (this.state.itemDetail.source.toUpperCase()) {
    //   case "TWITTER":

      if(event.target.name==="dateup"){
        orderArray=this.itemsSortInverse("date", this.state.items);
    }else if(event.target.name==="datedown"){
      orderArray=this.itemsSort("date", this.state.items);
      }else if(event.target.name==="reup"){
        orderArray=this.itemsSortInverse("order", this.state.items);
      }else if(event.target.name==="redown"){
        orderArray=this.itemsSort("order", this.state.items);
      }

    //   break;
    //   case "YOUTUBE":
    //   if(event.target.name==="dateup"){
    //     orderArray=this.itemsSort("publishedAt", this.state.items);
    //   }else if(event.target.name==="datedown"){
    //     orderArray=this.itemsSortInverse("publishedAt", this.state.items);
    //   }else if(event.target.name==="reup"){
    //     orderArray=this.itemsSort("order", this.state.items);
    //   }else if(event.target.name==="redown"){
    //     orderArray=this.itemsSort("order", this.state.items);
    //   }
    //
    //   break;
    //   default:
    //   console.log("no social");
    // }




      this.setState({order:event.target.name, items:orderArray});
  }

  itemsSort = (itemToOrder , dataArray) =>{
    let ascend = dataArray.slice();
    ascend.sort (function (a,b)
    {
        return new Date(a[itemToOrder]) - new Date(b[itemToOrder]);
      // return a[itemToOrder].localeCompare(b[itemToOrder]);
    }
  );
  return ascend;
  }
  itemsSortInverse = (itemToOrder,dataArray)=>{

    var descend = dataArray.slice();

    descend.sort (function (a, b)
    {
      return new Date(b[itemToOrder]) - new Date(a[itemToOrder]);

    }
  );
  return descend;
  }



  render() {


    let jsonlang = this.props.appstate.App.language;
    return (

      <div>
        {this.state.itemDetail!=null ?
          <div>

            <AppBar position="fixed" color="disabled" style={{paddingTop: 30}}>
              <Toolbar variant="dense"  color="inherit">



                {/* <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  >
                  <Grid item xs={3}>
                  <Tooltip title={<h2>BACK</h2>} >
                  <IconButton edge="start" color="inherit" aria-label="back"
                  onClick={() => { this.props.history.push('/');}}>
                  <ArrowBackIcon
                />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid item xs={9}>

          <Tooltip title={<h2>{this.state.itemDetail.source.toUpperCase()}</h2>} >
          <Typography
          className="ellips-soc"
          >
          {this.state.itemDetail.source.toUpperCase() ==="TWITTER"
          ? <TwitterIcon
          color="primary"
          className="icon-10"
        />
        : this.state.itemDetail.source.toUpperCase() ==="YOUTUBE" ?
        <YouTubeIcon
        color="secondary"
      />
      : this.state.itemDetail.source.toUpperCase() ==="DIGITALMEETS" ?
      <span alt="DIGITAL MEETS"
      style={{
      backgroundImage:`url("/images/icons/digital-meets-icon.jpg")`,
      position: 'absolute',
      backgroundSize: 'contain',
      backgroundPosition: 'center 40%',
      height:"15px",
      width:"85px",
      margin: "-15px 0px 0px -10px"
    }}
  />

  : this.state.itemDetail.source.toUpperCase() ==="AMNESTY" ?
  <span alt="AMNESTY"
  style={{
  backgroundImage:`url("/images/icons/amnesty-icon.jpg")`,
  position: 'absolute',
  backgroundSize: 'contain',
  backgroundPosition: 'center 40%',
  height:"24px",
  width:"22px",
  margin: "-20px 0px 0px 20px"
}}
/>

: this.state.itemDetail.source.toUpperCase() ==="COURAGEOPPOSITION" ?
<span alt="COURAGE OPPOSITION"
style={{
backgroundImage:`url("/images/icons/cultural-opposition-icon.png")`,
position: 'absolute',
backgroundSize: 'contain',
backgroundPosition: 'center 40%',
height:"24px",
width:"24px",
margin: "-20px 0px 0px 20px"
}}
/>

: <></>}
</Typography>
</Tooltip>

<Tooltip title={<h2>{this.state.itemDetail.keywords.toString()}</h2>}>
<Typography color='default' className="ellips-soc">
{this.state.itemDetail.keywords.toString()}
</Typography>
</Tooltip>

<Tooltip title={<h2>{new Date(this.state.itemDetail.createdAt).toUTCString().split(' ').slice(1).join(' ')}</h2>}>
<Typography color='default' className="ellips-soc">
{new Date(this.state.itemDetail.createdAt).toUTCString().split(' ').slice(1).join(' ')}
</Typography>
</Tooltip>

<Tooltip title={<h2>STATUS</h2>}>
<Typography
className="ellips-soc"
style={ this.getStatus(this.state.itemDetail.createdAt) === "running" ?{ color: "red" } :{  } }
>
{this.getStatus(this.state.itemDetail.createdAt) ==="running"? "RUNNING.." : "DONE"}
</Typography>
</Tooltip>
</Grid>
</Grid> */}

<Tooltip title={<h2>BACK</h2>} >
<IconButton edge="start" color="inherit" aria-label="back"
  onClick={() => { this.props.history.push('/');}}>
  <ArrowBackIcon
  />
</IconButton>
</Tooltip>

<div className="centerInfo">

  <Tooltip title={<h2>{this.state.itemDetail.source.toUpperCase()}</h2>} >
  <Typography
    className="ellips-soc"
    >
      {this.state.itemDetail.source.toUpperCase() ==="TWITTER"
      ? <TwitterIcon
        color="primary"
        className="icon-10"
      />
      : this.state.itemDetail.source.toUpperCase() ==="YOUTUBE" ?
      <YouTubeIcon
        color="secondary"
      />
      : this.state.itemDetail.source.toUpperCase() ==="DIGITALMEETS" ?
      <span alt="DIGITAL MEETS"
        style={{
          backgroundImage:`url("/images/icons/digital-meets-icon.jpg")`,
          position: 'absolute',
          backgroundSize: 'contain',
          backgroundPosition: 'center 40%',
          height:"15px",
          width:"85px",
          margin: "-15px 0px 0px -10px"
        }}
      />

      : this.state.itemDetail.source.toUpperCase() ==="AMNESTY" ?
      <span alt="AMNESTY"
        style={{
          backgroundImage:`url("/images/icons/amnesty-icon.jpg")`,
          position: 'absolute',
          backgroundSize: 'contain',
          backgroundPosition: 'center 40%',
          height:"24px",
          width:"22px",
          margin: "-20px 0px 0px 20px"
        }}
      />

      : this.state.itemDetail.source.toUpperCase() ==="COURAGEOPPOSITION" ?
      <span alt="COURAGE OPPOSITION"
        style={{
          backgroundImage:`url("/images/icons/cultural-opposition-icon.png")`,
          position: 'absolute',
          backgroundSize: 'contain',
          backgroundPosition: 'center 40%',
          height:"24px",
          width:"24px",
          margin: "-20px 0px 0px 20px"
        }}
      />

      : <></>}
    </Typography>
  </Tooltip>

  <Tooltip title={<h2>{this.state.itemDetail.keywords.toString()}</h2>}>
  <Typography color='default' className="ellips-soc">
    {this.state.itemDetail.keywords.toString()}
  </Typography>
</Tooltip>

<Tooltip title={<h2>{new Date(this.state.itemDetail.createdAt).toUTCString().split(' ').slice(1).join(' ')}</h2>}>
<Typography color='default' className="ellips-soc">
  {new Date(this.state.itemDetail.createdAt).toUTCString().split(' ').slice(1).join(' ')}
</Typography>
</Tooltip>

<Tooltip title={<h2>STATUS</h2>}>
<Typography
  className="ellips-soc"
  style={ this.getStatus(this.state.itemDetail.createdAt) === "updating" ?{ color: "red" } :{  } }
  >
    {this.getStatus(this.state.itemDetail.createdAt) ==="updating"? "UPDATING..." : "DONE"}
  </Typography>
</Tooltip>
</div>

{this.state.itemDetail.source.toUpperCase() ==="TWITTER" || this.state.itemDetail.source.toUpperCase() ==="YOUTUBE"
?
<>

<Checkbox
  checked={this.state.order==="reup" ? true : false}
  onChange={this.orderList}
  name="reup"
  color="primary"
  icon={<ArrowDropUpIcon fontSize="large" />}
  checkedIcon={<ArrowDropUpIcon fontSize="large"
    className="btn-dotted"/>}
  />

  {this.state.itemDetail.source.toUpperCase() ==="TWITTER"
  ?
  <Tooltip title={<h2>{jsonlang.orderby.toUpperCase()} RETWEET </h2>}>
  <RepeatIcon />
</Tooltip>
: this.state.itemDetail.source.toUpperCase() ==="YOUTUBE" ?
<Tooltip title={<h2>{jsonlang.orderby.toUpperCase()} RELEVANCE </h2>}>
<Star />
</Tooltip>
: <></>}

<Checkbox
checked={this.state.order==="redown" ? true : false}
onChange={this.orderList}
name="redown"
color="primary"
icon={<ArrowDropDownIcon fontSize="large" />}
checkedIcon={<ArrowDropDownIcon fontSize="large"
  className="btn-dotted"/>}
/>

<Divider
  style={{ height: 28, margin: 4 }}
  orientation="vertical"
/>


<Checkbox
  checked={this.state.order==="dateup" ? true : false}
  onChange={this.orderList}
  name="dateup"
  color="primary"
  icon={<ArrowDropUpIcon fontSize="large" />}
  checkedIcon={<ArrowDropUpIcon fontSize="large"
    className="btn-dotted"/>}
  />

  <Tooltip title={<h2>{jsonlang.datesort.toUpperCase()}</h2>}>
  <TodayIcon />
</Tooltip>
<Checkbox
  checked={this.state.order==="datedown" ? true : false}
  onChange={this.orderList}
  name="datedown"
  color="primary"
  icon={<ArrowDropDownIcon fontSize="large" />}
  checkedIcon={<ArrowDropDownIcon fontSize="large"
    className="btn-dotted"/>}
  />

</>

: <></>}

</Toolbar>
</AppBar>

<AppBar  position="fixed" color="default">
  <Typography
    variant='h6'
    justify='center'
    align='center'
    >
      {jsonlang.socialmedia.toUpperCase()}
    </Typography>
  </AppBar>
  {this.state.items.length>0 ?
    <div style={{paddingTop:100, paddingBottom:40}}>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        >
          {this.state.items.map((item, index) =>
            <Grid item xs={3}>

              <Card style={{margin:10}}>
                <CardHeader
                  avatar={
                    this.state.itemDetail.source ==="TWITTER"
                    ? <Avatar aria-label="avatar logo"
                      src={item.userImage}>

                    </Avatar>
                    : <></>
                  }
                  action={
                    this.state.itemDetail.source ==="TWITTER"
                    ? <IconButton aria-label="settings"><TwitterIcon
                      color="primary"
                    /></IconButton>
                    : this.state.itemDetail.source ==="YOUTUBE"
                    ? <IconButton aria-label="settings"><YouTubeIcon
                      color="secondary"
                    /></IconButton>
                    : null
                  }
                  title={
                    this.state.itemDetail.source ==="TWITTER"
                    ?
                    <div>
                      <Tooltip title={<h2>{item.userName}</h2>}>
                      <div>{item.userName}</div>
                    </Tooltip>
                    {/* <Tooltip title={<h2>{item.userScreenName}</h2>}>
                    <div>{item.userScreenName}</div>
                  </Tooltip> */}
                </div>
                :
                <Tooltip title={<h2>{item.title}</h2>}>
                <div>{item.title}</div>
              </Tooltip>
            }
          />
          <div
            onClick={()=> window.open(item.url, "_blank")}
            style={{cursor: "pointer"}}>
            {this.state.itemDetail.source !=="TWITTER" && item.thumbnailUrl!=="" ?
            <CardMedia
              image={item.thumbnailUrl}
              title={item.title}
              className="imagemedia"
            /> : null}
            <CardContent>
              <Typography variant="body2" color="textSecondary" className="textDesc">
                {item.description}
              </Typography>
            </CardContent>
          </div>
          <CardActions disableSpacing>
            <Typography variant="subtitle2" color="textSecondary">
              {new Date(item.date).toUTCString().split(' ').slice(1).join(' ')}
            </Typography>
            <IconButton
              style={{marginLeft: 'auto'}}
              // TEST // onClick={()=> window.open(item.url, "_blank")}
              onClick={()=>this.downloadCard(item)}
              aria-label={jsonlang.saveinres.toUpperCase()} //SAVE IN Resources Manager
              >
                <Tooltip title={<h2>{jsonlang.saveinres.toUpperCase()}</h2>}>
                <SystemUpdateAltIcon
                  style={{ color: "black" }}
                />
              </Tooltip>
            </IconButton>
          </CardActions>
        </Card>
      </Grid>
    )}
  </Grid>
</div>
:  <div style={{
  textAlign:"center",
  padding:"150px"
}} >{this.state.viewNoItem===false ? <CircularProgress/> : <></>}</div>}
</div>
: <div style={{
  textAlign:"center",
  padding:"150px"
}} >{this.state.viewNoItem===false ? <CircularProgress/> : <></>}</div>}
{this.state.viewNoItem===true ? <div style={{
  textAlign:"center"
}} >{jsonlang.notresults}</div> : null}

<>
<Snackbar open={this.state.downloadInfo} autoHideDuration={4000} onClose={this.handleCloseSnack}>
  <Alert onClose={this.handleCloseSnack} severity={this.state.severity}>
    {this.state.severity==="success" ? <h2>{jsonlang.savedinres.toUpperCase()}</h2> : <>{jsonlang.resourcerror.toUpperCase()}</>}
  </Alert>
</Snackbar>

</>
</div>

)
}
}

export default connect(mapStateToProps)(DetailSocialMedia);
